import React, { useEffect, useState } from 'react'
import { PageWrapper } from '../../components'
import { useSelector } from 'react-redux'
import InitialForm from '../../components/page-components/apps/supervisor-job-visit/initial-form'
import Loading from '../../components/page-components/apps/supervisor-job-visit/loading'
import Error from '../../components/page-components/apps/supervisor-job-visit/error'
import Success from '../../components/page-components/apps/supervisor-job-visit/success'

import { useLocation } from 'react-router-dom'

const SupervisorJobVisit = () => {
	// const [showForm, setShowForm] = useState(true)
	const createJobSiteVisitRdx = useSelector((state) => state.createJobSiteVisit)
	const { data, loading, error } = createJobSiteVisitRdx
	const location = useLocation()
	useEffect(() => {
		if (location?.search) {
			const params = new URLSearchParams(location.search)

			const job = params.get('jobid') || '-'

			const deeplink = `com.zeidos.romanroofing://add-visit/${encodeURIComponent(
				params.get('zip') || '-',
			)}/${encodeURIComponent(params.get('em') || '-')}/${encodeURIComponent(
				params.get('dn') || '-',
			)}/${encodeURIComponent(params.get('est') || '-')}/${encodeURIComponent(
				params.get('toc') || '-',
			)}/${encodeURIComponent(params.get('ic') || '-')}/${encodeURIComponent(
				job,
			)}`

			if (
				/android|iphone|ipad|ipod/i.test(navigator.userAgent) &&
				job !== '-'
			) {
				setTimeout(() => {
					window.location.href = deeplink
				}, 250) // allow the page to render + give WKWebView time
			}
		}
		return () => {}
	}, [location])

	// useEffect(() => {
	// 	if (error || loading || data?.length === 0) {
	// 		setShowForm(true)
	// 	} else setShowForm(false)

	// 	return () => {}
	// }, [error, data, loading])

	// useEffect(() => {
	// 	console.log(createJobSiteVisitRdx)

	// 	return () => {}
	// }, [createJobSiteVisitRdx])

	// const showFormHandler = () => {
	// 	setShowForm((prev) => !prev)
	// }

	return (
		<PageWrapper showNavigation={false}>
			<InitialForm
				showForm={true}
				// onShowForm={showFormHandler} REMOVED FROM COMPONENT
				data={data}
			/>
			{loading && <Loading />}
			{data && <Success data={data.data} message={data.message} />}
			{error && <Error error={error} />}
		</PageWrapper>
	)
}

export default SupervisorJobVisit
